import React from "react";
import { Box, Skeleton } from "@mui/material";
import Card from "./Card";

export const ComparativeCardSkeleton = () => (
  <Card
    header={{
      hardTitle: <Skeleton width={150} />,
    }}
    style={{
      minHeight: "auto",
      padding: "12px 16px",
    }}
  >
    <Box sx={{ position: "relative", width: "100%" }}>
      <Skeleton width={200} sx={{ mb: 2 }} />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          width: "100%",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Skeleton width={60} height={32} />
          <Skeleton width={80} />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Skeleton width={60} height={32} />
          <Skeleton width={120} />
        </Box>
      </Box>
    </Box>
  </Card>
);

export default ComparativeCardSkeleton;
